import React from 'react';
import { ProgressSpinner } from 'primereact/progressspinner';
import { FileUpload } from 'primereact/fileupload';

interface ImageUploadCardProps {
  onUpload: (files: File[]) => void;
  isUploading?: boolean;
}

const ImageUploadCard: React.FC<ImageUploadCardProps> = ({ onUpload, isUploading }) => {
  const fileUploadRef = React.useRef<FileUpload>(null);

  const handleFileSelect = (e: any) => {
    const files = e.files;
    if (files && files.length > 0) {
      onUpload(Array.from(files));
    }
  };

  return (
    <div 
      className="border-2 border-dashed border-primary border-round p-4 text-center cursor-pointer transition-all duration-200 hover:bg-primary-50 hover:border-primary-300"
      onClick={() => fileUploadRef.current?.getInput()?.click()}
    >
      {isUploading ? (
        <div className="flex flex-column align-items-center justify-content-center h-full">
          <ProgressSpinner style={{ width: '30px', height: '30px' }} strokeWidth="4" />
          <p className="text-primary text-sm mt-2 mb-0">Uploading...</p>
        </div>
      ) : (
        <div className="flex flex-column align-items-center justify-content-center h-full">
          <i className="pi pi-plus text-primary text-4xl mb-2"></i>
          <p className="text-primary text-sm mb-0">Add Images</p>
        </div>
      )}
      
      <FileUpload
        ref={fileUploadRef}
        mode="basic"
        accept="image/*"
        multiple
        className="hidden"
        onSelect={handleFileSelect}
        chooseOptions={{ style: { display: 'none' } }}
      />
    </div>
  );
};

export default ImageUploadCard;